var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21418 1.87667L5.33323 9.60314C5.41574 9.72761 5.5181 9.82753 5.63327 9.89603C5.74844 9.96453 5.87371 10 6.00048 10C6.12725 10 6.25252 9.96453 6.3677 9.89603C6.48287 9.82753 6.58523 9.72761 6.66774 9.60314L11.7868 1.87667C12.2753 1.13917 11.8703 0 11.1195 0H0.879971C0.129216 0 -0.275825 1.13917 0.21418 1.87667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/ArrowDropDown.2316223443ddc5202148015678a71443.svg";
export { ForwardRef as ReactComponent };